export const IS_SUBSCRIBED_STATUS = "subscribed";
export const IS_UNSUBSCRIBED_STATUS = "unsubscribed";
export const IS_SUBSCRIPTION_PENDING_STATUS = "subscription_pending";
export const IS_UNSUBSCRIPTION_PENDING_STATUS = "unsubscription_pending";

export const isSubscribed = (status) => status === IS_SUBSCRIBED_STATUS;
export const isUnSubscribed = (status) => status === IS_UNSUBSCRIBED_STATUS;
export const isSubscriptionPending = (status) => status === IS_SUBSCRIPTION_PENDING_STATUS;
export const isUnSubscriptionPending = (status) => status === IS_UNSUBSCRIPTION_PENDING_STATUS;
